// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__295Jf","inner":"Footer_inner__20s8M"};